import * as React from 'react';
import {
    Grid, Card, TextField, CardContent, Box, 
    Typography, Divider,
    CircularProgress,
    CardActionArea,
    useTheme,
  } from '@mui/material'

import SearchCard from "components/SearchCard";
import constants from 'assets/constants';
import { stripAccents, disp_rank_short, tokenSearch, fetchPlayerList } from 'assets/utils';
import { useTranslation } from "react-i18next";

export default function UserSearchCard ({fetchData}) {

    const theme = useTheme()
    const { t } = useTranslation()

    return <SearchCard
        fetchData={fetchData}
        fetchList={fetchPlayerList}
        searchMethod={tokenSearch}
        MIN_LENGTH = {5}
        generalText={{placeholder: t("search.playerPlaceholder"), noResults: t("search.playerNoResults")}}
        listItem={(index, el, handleClick) => 
            <React.Fragment key={el["name"] + el["club_id"] + el["id"]}>
            {index > 0? <Divider/> : null}
            <CardActionArea onClick={()=>{handleClick(el)}} sx={{pl: 2, pt: 1, pb: 1}}>
            <Typography variant="body2" sx={{fontWeight: "bold"}}>{el["name"]}</Typography>
            <Typography variant="caption">{el["singles"] !== undefined ? <><b style={{color: theme.palette.primary.main}}>{disp_rank_short(el["singles"], el["category"])}</b><b> • </b></> : null}{el["name_club"]}</Typography>
            </CardActionArea>

            </React.Fragment>
        }
    />
}